import React from 'react';

import { MailSubscriptionPage } from '@/pages/mailSubscription';

import { EVENT_OPEN_MODAL, MAX_WIDTH_MODAL } from '@/entities/mailSubscription';

import { AppProviders } from '@/shared/components/Providers';
import { APP_ELEMENTS, MODAL_ELEMENTS } from '@/shared/constants';
import { Modal } from '@/shared/services/modal';
import { Notification } from '@/shared/services/notification';
import { MailSubscriptionTheme } from '@/shared/themes';

import store from './store';

const App: React.FC = () => {
  return (
    <AppProviders
      resources={window.mailSubscription.resources}
      store={store}
      theme={MailSubscriptionTheme}
    >
      <MailSubscriptionPage />
      <Modal
        appElement={APP_ELEMENTS.MAIL_SUBSCRIPTION}
        parentSelector={MODAL_ELEMENTS.MAIL_SUBSCRIPTION_MODAL}
        style={{
          content: {
            maxWidth: MAX_WIDTH_MODAL,
          },
        }}
        className="md:!r-absolute md:!r-bottom-10 md:!r-right-10 !r-top-auto
        md:r-overflow-auto r-max-h-[calc(100vh-40px)]
        "
        htmlOpenClassName="md:r-overflow-auto"
        eventName={EVENT_OPEN_MODAL}
      />
      <Notification />
    </AppProviders>
  );
};

export default App;
